import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import classname from 'classname';
import Popover from '../../../shared/popover';
import ColumnControlForm from './form/main';

lessRequire('modules/statistics/components/column-control/main.less');

const ColumnControl = ({ config, dispatchFormAction, onToggle, onApply, onReset, intl }) => {
	const { isOpen, isApplied, childColumns, form, type } = config;

	const headControl = (
		<span
			className={classname({
				'column-control__head': true,
				'is-open': isOpen,
				'is-applied': isApplied
			})}
			onClick={e => onToggle(type)}
		/>
	);

	return (
		<div className="column-control">
			<Popover head={headControl} isShow={isOpen} onOutSideClick={e => onToggle(type)}>
				<div className="column-control__suggest">
					<ColumnControlForm
						childColumns={childColumns}
						type={type}
						initialValues={form}
						dispatchFormAction={dispatchFormAction}
						onApply={onApply}
						onReset={onReset}
						intl={intl}
					/>
				</div>
			</Popover>
		</div>
	);
};

ColumnControl.propTypes = {
	config: PropTypes.object,
	dispatchFormAction: PropTypes.func,
	onToggle: PropTypes.func,
	onApply: PropTypes.func,
	onReset: PropTypes.func,
	intl: PropTypes.func
};

export default ColumnControl;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/column-control/main.js